module.exports = __webpack_public_path__ + "static/media/pepita.21e4662c.png";